import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class ListagemVendaGuard implements CanActivate {
    private redirecting = false;

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
        if (!this.authService.isAtuthenticated()) {
            this.authService.logout();
        }
    }

    private navigateToVendas(tipoVenda: 'simples' | 'integracao', stateUrl?: string): void {
        const urlContext = stateUrl ?? this.router.url;
        const query = urlContext.includes('?') ? urlContext.substring(urlContext.indexOf('?')) : '';

        if (urlContext.startsWith('/v2/')) {
            this.router.navigateByUrl(`/v2/notificacoes/vendas/${tipoVenda}${query}`);
        } else {
            this.router.navigateByUrl(`/vendas/${tipoVenda}${query}`);
        }
    }

    private isAllowedSalesRoute(url: string): boolean {
        const pathOnly = url.split('?')[0];
        return (
            /\/v2\/notificacoes\/vendas\/integracao(\/|$)/.test(pathOnly) ||
            /^\/vendas\/integracao(\/|$)/.test(pathOnly)
        );
    }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.redirecting) {
            this.redirecting = false;
            return true;
        }

        // Already on an allowed sales route. Allow through without the redirect dance.
        if (this.isAllowedSalesRoute(state.url)) {
            return true;
        }

        this.redirecting = true;
        this.navigateToVendas('integracao', state.url);
        return false;
    }
}
